import React from "react";
import ModalComponent from "../../../components/modal";
import CreateContract from "./CreateContract";
import ToastMessage from "../../../components/toastMessage";
import { useState } from "react";

function CreateContractModal({
    showNewContractModal,
    handleCloseNewContractModal,
    ownerId,
    ownerType,
}) {
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const onSuccess = () => {
        handleCloseNewContractModal();
        setShowSuccessMessage(true);
    };
    return (
        <>
            <ModalComponent
                header="New Contract"
                open={showNewContractModal}
                onClose={handleCloseNewContractModal}
                size="large"
                borderedHeader
            >
                <CreateContract
                    onClose={handleCloseNewContractModal}
                    onSuccess={onSuccess}
                    ownerId={ownerId}
                    ownerType={ownerType}
                />
            </ModalComponent>
            {showSuccessMessage && (
                <ToastMessage
                    type="success"
                    showToast={showSuccessMessage}
                    setShowToast={setShowSuccessMessage}
                    name="New contract"
                    text="has been created successfully and is pending
                    verification."
                />
            )}
        </>
    );
}

export default CreateContractModal;
